import { useEffect, useState } from 'react';
import { Autocomplete, TextField, Tooltip } from '@mui/material';
import licenseService from '../../pages/licenses/licenseService';

function useLicenseSelect() {
  const [licenses, setLicenses] = useState<any[]>([]);

  useEffect(() => {
    licenseService.list().then((response) => {
      if (!response.hasError) {
        setLicenses(response.records);
      }
    });
  }, []);

  const LicenseSelect = (props: any) => {
    const { value, onChange } = props;

    return (
      <Autocomplete
        options={licenses.map((x) => x.id)}
        getOptionLabel={(option) =>
          licenses.find((x) => x.id === option)?.name ?? ''
        }
        value={value}
        onChange={onChange}
        renderInput={(params) => (
          <Tooltip title={licenses.find((x) => x.id === value)?.description}>
            <TextField {...params} label="License" variant="outlined" />
          </Tooltip>
        )}
      />
    );
  };

  return { LicenseSelect, licenses };
}

export default useLicenseSelect;
